import {Component, OnInit} from '@angular/core';
import { navItems } from '../../_nav';
import {environment} from '../../../environments/environment';
import {AuthService} from '../../../services/auth.service';
import {Router} from '@angular/router';
import {UserService} from '../../../services/user.service';
import Swal from 'sweetalert2';
import {User} from '../../../models/user.model';
import { RoleService } from '../../../services/role.service';
import { NotificationService } from '../../../services/notification.service';
import {ContactService} from "../../../services/contact.service";
import { SharedService } from '../../page/shared.service';
import { Subscription, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';


@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent  implements OnInit {
  public sidebarMinimized = false;
  public navItems = navItems;
  userRoles: string[];
  env: String = '';
  // @ts-ignore
  user: User = [];
  isKahpoo: boolean;
  subscription !: Subscription;
  concatInfosNotReplied: [] = [];
  chatNotifications: Notification[] = [];

  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
  constructor(private authService: AuthService, private router: Router,
              private userService: UserService, private roleService: RoleService,
              private notificationService: NotificationService,
              public sharedSevice: SharedService,
              private contactInfoService: ContactService) { }

  ngOnInit(): void {
    this.authService.isAuthenticated();
    this.loadPersonalInformation();

    this.env = localStorage.getItem('env');
    // console.log(environment.url);
    this.userRoles = ['admin', 'manager'];

    this.loadChatNotification();

    this.getAllMessageNotReplied();
  }

  getAllMessageNotReplied() {
    this.contactInfoService.getContact().subscribe(data => {
      this.concatInfosNotReplied = data;
    }, error => {
      // console.log(error);
    });
  }

  // loadChatNotification() {
  //   this.notificationService.getChatNotification().subscribe(rs => {
  //     this.chatNotifications = rs;
  //     this.sharedSevice.valeurPartagee = this.chatNotifications.length;
  //   });
  // }

  loadChatNotification() {
    this.subscription = timer(0, 60000).pipe(
      switchMap(() => this.notificationService.getChatNotification()
      )
    ).subscribe(result => {
        this.chatNotifications = result;
        this.sharedSevice.valeurPartagee = this.chatNotifications.length;
      }
    );
  }

  editNotification(id: any) {
    this.notificationService.markNotificationAsRead(id).subscribe(rs => {
      this.initNotif();
    });
  }

  initNotif() {
    this.loadChatNotification();
  }

  isViewAuditAutorized = false;
  loadPersonalInformation = () => {
    this.authService.getUSerBySessionId().subscribe(
      (rest: any) => {
        this.user = rest;
        this.isKahpoo = rest.kahpoo;
        // console.log("this.isKahpoo");
        // console.log(this.isKahpoo);
        //console.log("Connected User");
        //console.log(this.user);
        rest.minimizedRoles.forEach(r => {
          this.roleService.getidRole(r).subscribe(r => {
            if (r?.name?.includes("BO_VIEW_AUDIT")) {
              this.isViewAuditAutorized = true;
            }
          })
        })
      }, (error: any) => {
      //  console.log(error);
      }
    );
  }

  disconnect() {
    this.authService.deleteSession().subscribe(rs => {
     // console.log(rs);
    });
    this.router.navigate(['/login']);
  }

  onChangeEnv(value: any) {
    if (value !== this.env) {
      if (confirm('voulez vous vraiment quitter l\'environnement de ' + this.env + ' ?')) {
        this.authService.saveEnvironement(value);
        Swal.fire({
          position: 'top-end',
          icon: 'success',
          title: 'Veuillez vous Reconnectez à nouveau pour accéder à l\'environement ' + value,
          showConfirmButton: false,
          timer: 3500
        });
        this.disconnect();
      }
    }
  }

}
